import * as yup from 'yup';
import { LegalStatus, LegalStatusType } from '../types';

export const createLegalDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  content: yup.string().required().label('Content'),
  type: yup.mixed<LegalStatusType>().oneOf(Object.values(LegalStatusType)).required().label('Type'),
  status: yup.mixed<LegalStatus>().oneOf(Object.values(LegalStatus)).required().label('Status')
});

export const updateLegalDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  content: yup.string().required().label('Content'),
  type: yup.mixed<LegalStatusType>().oneOf(Object.values(LegalStatusType)).required().label('Type'),
  status: yup.mixed<LegalStatus>().oneOf(Object.values(LegalStatus)).required().label('Status')
});
